module.exports = __webpack_public_path__ + "static/img/1_1.81da32e5.jpg";